export function getFileSizeString(filesize: number): string {
  // If less than 1 KB, show in B
  if (filesize < 1024) {
    return `${filesize} bytes`;
  }

  // If less than 1 MB, show in KB
  if (filesize < 1048576) {
    return `${Math.round((filesize * 100) / 1024.0) / 100} KB`;
  }

  // If less than 1 GB, show in MB
  if (filesize < 5368709120) {
    return `${Math.round((filesize * 100) / 1048576.0) / 100} MB`;
  }

  // Else, show in GB
  return `${Math.round((filesize * 100) / 5368709120.0) / 100} GB`;
}
